import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface OrganizationTemplateConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function OrganizationTemplateConfirmDialog(props: OrganizationTemplateConfirmDialogProps) {
  const { t } = useTranslation('knowledge');

  return (
    <AlertDialog
      open={props.open}
      onOpenChange={(open: boolean) => {
        if (!open) props.onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('knowledgeHub.briefTemplateOrganizationConfirm.title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('knowledgeHub.briefTemplateOrganizationConfirm.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            {t('knowledgeHub.briefTemplateOrganizationConfirm.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={props.onConfirm}>
            {t('knowledgeHub.briefTemplateOrganizationConfirm.continue')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
